// extracted by mini-css-extract-plugin
export var hidden = "_tg-0";